import { render, staticRenderFns } from "./alive.vue?vue&type=template&id=49983d9e&scoped=true&"
import script from "./alive.vue?vue&type=script&lang=js&"
export * from "./alive.vue?vue&type=script&lang=js&"
import style0 from "./alive.vue?vue&type=style&index=0&id=49983d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49983d9e",
  null
  
)

export default component.exports